import React from 'react';
import { Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import { FaSearch, FaTimes } from 'react-icons/fa';
import FiltrosOcorrenciasBase from '~/Components/Ocorrencias/FiltrosOcorrenciasBase';

/**
 * Card de filtros específico da tela ConsultaOcorrenciasContas.
 * Estende FiltrosOcorrenciasBase com Cliente (conta) + Texto + botões específicos.
 *
 * W-0488 fix freeze: o Cliente NAO usa mais react-select com a lista completa de
 * contas (LookupContas sem termo de busca podia retornar centenas de milhares de
 * linhas -> o menu do react-select renderizava todas de uma vez e travava a aba).
 * Agora a selecao e feita via ModalBuscaContas (busca server-side com termo),
 * exibindo apenas a conta escolhida.
 */
const FiltrosOcorrenciasContas = ({
  filtros,
  setFiltros,
  onConsultar,
  onLimpar,
  onClienteTexto,
  onFiltrarTitulos,
  onAbrirBuscaContas,
  clienteSelecionadoLabel,
  opcoesGE,
  opcoesEmpreendimento,
  opcoesUsuario,
  loadingLookups,
  usuarioSemGe,
  titulosFiltroAtivo,
}) => {
  const handleChange = (campo, valor) => {
    setFiltros((prev) => ({ ...prev, [campo]: valor }));
  };

  const limparCliente = () => {
    setFiltros((prev) => ({ ...prev, codigo_conta: null, codigo_conta_label: null }));
  };

  const slotDepoisUsuario = (
    <>
      <Col md={3} sm={6} className="mb-2">
        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Cliente</Form.Label>
        <InputGroup size="sm">
          <Form.Control
            readOnly
            value={clienteSelecionadoLabel || ''}
            placeholder="Todos"
            onClick={usuarioSemGe ? undefined : onAbrirBuscaContas}
            disabled={usuarioSemGe}
            style={{ background: '#fff', cursor: usuarioSemGe ? 'not-allowed' : 'pointer' }}
          />
          {filtros.codigo_conta ? (
            <InputGroup.Append>
              <Button variant="outline-secondary" onClick={limparCliente} disabled={usuarioSemGe} title="Limpar cliente">
                <FaTimes />
              </Button>
            </InputGroup.Append>
          ) : null}
          <InputGroup.Append>
            <Button variant="outline-primary" onClick={onAbrirBuscaContas} disabled={usuarioSemGe} title="Buscar conta">
              <FaSearch />
            </Button>
          </InputGroup.Append>
        </InputGroup>
      </Col>
      <Col md={2} sm={6} className="mb-2">
        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Texto</Form.Label>
        <InputGroup size="sm">
          <InputGroup.Prepend>
            <InputGroup.Text><FaSearch /></InputGroup.Text>
          </InputGroup.Prepend>
          <Form.Control
            placeholder="Busca..."
            value={filtros.texto || ''}
            onChange={(e) => handleChange('texto', e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') onConsultar(); }}
            disabled={usuarioSemGe}
          />
        </InputGroup>
      </Col>
      <Col md={2} sm={6} className="mb-2 d-flex align-items-end">
        <Form.Check
          type="checkbox"
          label="Detalhar"
          checked={filtros.detalhar === true}
          onChange={(e) => handleChange('detalhar', e.target.checked)}
          disabled={usuarioSemGe}
          style={{ fontSize: 12 }}
        />
      </Col>
    </>
  );

  const slotAcoesDireita = (
    <>
      <Button
        size="sm"
        variant="outline-info"
        onClick={onClienteTexto}
        disabled={usuarioSemGe}
      >
        Cliente/Texto
      </Button>
      <Button
        size="sm"
        variant={titulosFiltroAtivo ? 'warning' : 'outline-warning'}
        onClick={onFiltrarTitulos}
        disabled={usuarioSemGe}
      >
        Filtrar Títulos
      </Button>
    </>
  );

  return (
    <FiltrosOcorrenciasBase
      filtros={filtros}
      setFiltros={setFiltros}
      onConsultar={onConsultar}
      onLimpar={onLimpar}
      opcoesGE={opcoesGE}
      opcoesEmpreendimento={opcoesEmpreendimento}
      opcoesUsuario={opcoesUsuario}
      loadingLookups={loadingLookups}
      usuarioSemGe={usuarioSemGe}
      slots={{
        depoisUsuario: slotDepoisUsuario,
        acoesDireita: slotAcoesDireita,
      }}
    />
  );
};

export default FiltrosOcorrenciasContas;
